import { core, dateUtil } from '@/core'
import Basic from '@basic'
import { TimeSpinner } from '@bag'

const util = {
  pullTimePanel(opt, tar) {
    const { content } = tar.members
    const option = {}
    const time = new TimeSpinner(Object.assign({}, opt, option))
    content.append(time.unit)
    return time
  },
  template: {
    panel(opt, tar) {
      return $(`
      <div class="time-panel lt-popper">
        <div id="content" class="time-panel__content"></div>
        <div id="footer" class="time-panel__footer">
          <button id="cancel" type="button" class="time-panel__btn cancel">取消</button>
          <button id="sure" type="button" class="time-panel__btn confirm">确认</button>
        </div>
      </div>`)
    },
  },
  updater: {
    // 基本功能: 是否显示
    show(value, opt, tar, node) {
      if (value) {
        tar.unit.show()
      } else {
        tar.unit.hide()
      }
      tar.shown()
      tar.timePanel.shown(value)
    },
    // 基本功能: 显示层级
    level(value, opt, tar, node) {
      tar.table.map((item) => {
        if (item) {
          item.show = false
        }
      })
      tar.table[value] && (tar.table[value].show = true)
      const { yearLabel, monthLabel, prevMonth, nextMonth } = tar.members
      if (value === 0) {
        monthLabel.hide()
        prevMonth.hide()
        nextMonth.hide()
      } else if (value === 1) {
        monthLabel.hide()
        prevMonth.hide()
        nextMonth.hide()
      } else if (value === 2) {
        monthLabel.show()
        prevMonth.show()
        nextMonth.show()
      }
      util.titleChange(opt, tar)
    },
    // 基本功能: date
    date(value, opt, tar, node) {
      tar.timePanel.date = value
    },
    // 扩展功能: 左侧快捷键
    shortcut(value, opt, tar, node) {
      const { sidebar, body } = tar.members
      if (value) {
        tar.unit.addClass('has-sidebar')
        body.before(sidebar)
      } else {
        tar.unit.removeClass('has-sidebar')
        sidebar.detach()
      }
    },
  },
}

export default class TimePanel extends Basic {
  constructor(opt) {
    super(opt)
    this.defaults = {
      show: false, // 基本功能: 是否显示
      date: new Date(), // 基本功能: 设置时间
      // popperClass: '',
      // format: 'HH:mm:ss',
      // value: '',
      // defaultValue: null,
      // date: new Date(),
      // oldValue: new Date(),
      // selectableRange: [],
      // selectionRange: [0, 2],
      // disabled: false,
      // arrowControl: false,
      // needInitAdjust: true
    }
    this.events = {
      click: null,
      cancel: 'onCancel',
      sure: 'onSure',
      shown: 'onShown',
    }
    this.settings = Object.assign({}, this.defaults, opt)
    core.proxyApi(this) // 核心属性处理
    core.proxyEvent(this) // 核心事件处理
    this.init()
  }

  init() {
    const opt = this.settings
    const template = util.template.panel(opt, this)
    const members = {}
    core.compileSymbol(template[0], members)
    this.members = members
    this.unit = template
    this.table = []
    this.timePanel = util.pullTimePanel(opt, this)
    core.update(util.updater, opt, this)
    this.bindInput()
  }

  bindInput() {
    const { cancel, sure } = this.members
    this.timePanel.choose($.proxy(this.handleDateClick, this))
    cancel.click($.proxy(this.cancel, this))
    sure.click($.proxy(this.sure, this))
  }

  handleDateClick(tar, value) {
    this.date = value
    this.click()
  }

  onSure() {
    this.key = false
  }

  onCancel() {
    this.date = this.oldValue
    this.key = false
  }

  onShown() {
    this.key = true
  }
}
